import React, { useState, useEffect } from "react";
import { AiFillEye, AiFillGithub } from "react-icons/ai";

import { AppWrap, MotionWrap } from "../../wrapper";
import { urlFor, client } from "../../client";

import "./Work.scss";

const Work = () => {
  const [showMore, setShowMore] = useState(false);
  const [isThree, setIsThree] = useState(true);
  const [works, setWorks] = useState([]);
  const [filterWork, setFilterWork] = useState([]);
  const [activeFilter, setActiveFilter] = useState("All");

  useEffect(() => {
    const query = '*[_type == "works"]';

    client.fetch(query).then((data) => {
      let reversedData = [...data].reverse();
      setWorks(reversedData);
      setFilterWork(reversedData);
    });
  }, []);

  const toggle = () => {
    setShowMore(!showMore);
  };

  const handleWorkFilter = (item) => {
    setShowMore(false);
    if (item === activeFilter) return;
    setActiveFilter(item);
    if (item === "All") {
      setFilterWork(works);
    } else {
      setFilterWork(
        works.filter((work) =>
          work.tags.some(
            (tag) =>
              tag && tag.trim().toLowerCase() === item.trim().toLowerCase()
          )
        )
      );
    }
  };

  useEffect(() => {
    if (filterWork.length > 3) {
      setIsThree(true);
    } else {
      setIsThree(false);
    }
  }, [filterWork]);

  return (
    <>
      <h2 className="head-text">
        My Creative <span>Portfolio</span> Section
      </h2>

      <div className="app__work-filter">
        {[
          "Agentic AI",
          "Machine Learning",
          "Deep Learning",
          "Web Development",
          "All",
        ].map((item, index) => (
          <div
            key={index}
            onClick={() => handleWorkFilter(item)}
            className={`app__work-filter-item app__flex p-text ${
              activeFilter === item ? "item-active" : ""
            }`}
          >
            {item}
          </div>
        ))}
      </div>

      <div className="app__work-portfolio">
        {!showMore
          ? filterWork.slice(0, 3).map((work, index) => (
              <div className="app__work-item app__flex" key={work._id || index}>
                <div className="app__work-img app__flex">
                  <img src={urlFor(work.imgUrl)} alt={work.name} />
                  <div className="app__work-hover app__flex">
                    <a href={work.projectLink} target="_blank" rel="noopener noreferrer">
                      <div className="app__flex">
                        <AiFillEye />
                      </div>
                    </a>
                    <a href={work.codeLink} target="_blank" rel="noopener noreferrer">
                      <div className="app__flex">
                        <AiFillGithub />
                      </div>
                    </a>
                  </div>
                </div>
                <div className="app__work-content app__flex">
                  <h4 className="bold-text">{work.title}</h4>
                  <p className="p-text" style={{ marginTop: 10 }}>
                    {work.description}
                  </p>
                  <div className="app__work-tag app__flex">
                    <p className="p-text">{work.tags[0]}</p>
                  </div>
                </div>
              </div>
            ))
          : filterWork.map((work, index) => (
              <div className="app__work-item app__flex" key={work._id || index}>
                <div className="app__work-img app__flex">
                  <img src={urlFor(work.imgUrl)} alt={work.name} />
                  <div className="app__work-hover app__flex">
                    <a href={work.projectLink} target="_blank" rel="noopener noreferrer">
                      <div className="app__flex">
                        <AiFillEye />
                      </div>
                    </a>
                    <a href={work.codeLink} target="_blank" rel="noopener noreferrer">
                      <div className="app__flex">
                        <AiFillGithub />
                      </div>
                    </a>
                  </div>
                </div>
                <div className="app__work-content app__flex">
                  <h4 className="bold-text">{work.title}</h4>
                  <p className="p-text" style={{ marginTop: 10 }}>
                    {work.description}
                  </p>
                  <div className="app__work-tag app__flex">
                    <p className="p-text">{work.tags[0]}</p>
                  </div>
                </div>
              </div>
            ))}
      </div>
      {isThree && (
        <div className="app_show_more_div">
          {showMore ? (
            <p onClick={toggle}>Show Less</p>
          ) : (
            <p onClick={toggle}>Show More </p>
          )}
        </div>
      )}
    </>
  );
};

export default AppWrap(
  MotionWrap(Work, "app__works"),
  "projects",
  "app__primarybg"
);
